import Base from './base';

interface Login {
    email: string,
    password: string
}

interface UserUpdate {
    first_name: string,
    last_name: string,
    business_name: string,
    phone: string,
    email: string
}

interface ChangePassword {
    oldPassword: string,
    newPassword: string
}

interface Payment {
    number: string,
    exp_month: number,
    exp_year: number,
    cvc: string
}

interface Unsubscribe {
    token: string,
    type: number,
    action: string
}

class Consumer extends Base {

    me() {
        return this.get('consumer/me');
    }

    userExist(data: any) {
        return this.post('consumer/exists', data);
    }

    login(data: Login) {
        return this.post('consumer/login', data)
    }

    update(data: UserUpdate) {
        return this.put('consumer', data)
    }

    uploadAvatar(data: any) {
        return this.upload('consumer/change-avatar', data)
    }

    removeAvatar() {
        return this.delete('consumer/remove-avatar')
    }

    deleteUser() {
        return this.delete('consumer', {})
    }

    changePassword(data: ChangePassword) {
        return this.post('consumer/change-password', data)
    }

    forgotPassword(data: any) {
        return this.post(`consumer/forget-password`, data)
    }

    checkResetPassToken(token: any) {
        return this.get(`consumer/forget-password/${token}`)
    }

    resetPassword(data: any) {
        return this.post(`consumer/reset-password`, data)
    }

    updatePayment(data: Payment) {
        return this.post('consumer/update-payment', data)
    }

    unsubscribe(data: Unsubscribe) {
        return this.post(`consumer/unsubscribe/${data.token}/${data.type}/${data.action}`)
    }

}

export default new Consumer();
